<template>
  <v-content>
    <v-container fluid style="position: relative">
      <v-row no-gutters>
        <v-col cols="12">
          <v-card>
            <v-container fluid>
              <v-card-title>      
                <v-btn icon @click="gotoUsers">
                  <v-icon>mdi-arrow-left</v-icon>
                </v-btn>
                {{ 'Users' | translate }}
              </v-card-title>
              <v-divider></v-divider>

               <v-card>
                <v-tabs
                v-model="maintabs"
                >
                    <v-tabs-slider></v-tabs-slider>
                    <v-tab v-if="currentUser.roles.includes(1) || currentUser.roles.includes(3) || currentUser.permissions.includes('can-assign-custom-role') || currentUser.permissions.includes('can-audit-user-history')" href="#viewUserTab" @click="closeallpanels()"> {{ 'User' | translate}} </v-tab>
                    <v-tab v-if="currentUser.roles.includes(1) || currentUser.roles.includes(3) || currentUser.permissions.includes('can-audit-user-history')" href="#viewUserDocuments" @click="closeallpanels()"> {{ 'User Documents' | translate }} </v-tab>
                    <v-tab v-if="currentUser.roles.includes(1) || currentUser.roles.includes(3) || currentUser.permissions.includes('can-audit-user-history')" href="#viewUserActivity" @click="closeallpanels()"> {{ 'User Activity' | translate }} </v-tab>
                    <v-tab v-if="currentUser.roles.includes(1) || currentUser.roles.includes(3) || currentUser.permissions.includes('can-audit-user-history')" href="#viewUserStats" @click="fetchUserStats()"> {{ 'User Statistics' | translate }} </v-tab>
                </v-tabs>
            
                <v-tabs-items v-model="maintabs">
                    <v-tab-item value="viewUserTab">
                        <v-card flat> 
                           <v-card-text>
                            <v-row v-if="errors != 'Seats are full'">
                              <v-col cols="12" sm="8" md="8">
                                <v-alert
                                  dense
                                  v-for="(v, k) in errors"
                                  :key="k"
                                  outlined
                                  type="error"
                                >{{ k }} {{ v }}</v-alert>
                              </v-col>
                            </v-row>
                            <v-row v-else>
                              <v-col cols="12" sm="8" md="8">
                                <v-alert dense outlined type="error">{{ errors }}</v-alert>
                              </v-col>
                            </v-row>
                            <v-form id="form" ref="form">
                              <v-row>
                                <v-col cols="12" sm="8" md="8">
                                  <v-row>
                                    <v-col cols="12" sm="3">
                                      <v-text-field
                                        v-model="salutation"
                                        :label="'Title' | translate"
                                        name="title"
                                        :rules="salutationRules"
                                        :disabled="(Object.keys(currentUser).length !=0 && currentUser.roles.includes(1)? false :true )"
                                        outlined
                                        required
                                      >
                                      <template #message="{ message }">
                                        {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                                      </template>               
                                      </v-text-field>
                                    </v-col>
                                    <v-col cols="9" sm="9">
                                      <v-text-field
                                        outlined
                                        :label="'Name' | translate"
                                        v-model="name"
                                        name="name"
                                        :rules="nameRules"
                                        autocomplete="off"
                                        :disabled="(Object.keys(currentUser).length !=0 && currentUser.roles.includes(1)? false :true )"
                                        required
                                      >      
                                      <template #message="{ message }">
                                        {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                                      </template>               
                                      </v-text-field>
                                    </v-col>
                                  </v-row>

                                  <v-row>
                                    <v-col cols="12" sm="12">
                                      <v-text-field
                                        outlined
                                        :label="'Email' | translate"
                                        v-model="email"
                                        name="email"
                                        autocomplete="off"
                                        :rules="emailRules"
                                        type="email"
                                        :disabled="(Object.keys(currentUser).length !=0 && currentUser.roles.includes(1)? false :true )"
                                        required
                                      >
                                      <template #message="{ message }">
                                        {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                                      </template>                                         
                                      </v-text-field>
                                    </v-col>
                                  </v-row>

                                  <v-row>
                                    <v-col cols="12" sm="12">
                                      <v-text-field
                                        outlined
                                        :label="'Phone Number' | translate"
                                        v-model="phone_no"
                                        name="phone_no"
                                        autocomplete="off"
                                        :rules="numberRules"
                                        type="text"
                                        :disabled="(Object.keys(currentUser).length !=0 && currentUser.roles.includes(1)? false :true )"
                                        required
                                      >
                                      <template #message="{ message }">
                                        {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                                      </template>                                         
                                      </v-text-field>
                                    </v-col>
                                  </v-row>

                                  <v-row>
                                    <v-col cols="12" sm="12">
                                      <v-select
                                        v-model="selectedLanguage"
                                        :items="languagesdata"
                                        item-value="lang_code"
                                        :item-text="'lang_name' | translate"
                                        :label="'Language' | translate"
                                        outlined
                                      ></v-select>
                                    </v-col>
                                  </v-row>

                                  <v-row>
                                    <v-col cols="12" sm="12">
                                      <v-textarea
                                        outlined
                                        name="address"
                                        v-model="address"
                                        :rules="addressRules"
                                        autocomplete="off"
                                        :disabled="(Object.keys(currentUser).length !=0 && currentUser.roles.includes(1)? false :true )"
                                        :label="'Address' | translate"
                                      >
                            

                                      <template #message="{ message }">
                                        {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                                      </template>               
                                      </v-textarea>
                                    </v-col>
                                  </v-row>

                                
                                </v-col>

                                <v-col cols="12" sm="4" md="4">
                                  <v-row v-if='Object.keys(currentUser).length !=0 && (currentUser.roles.includes(1)  || currentUser.roles.includes(3))'>
                                    <v-col cols="12" sm="12" md="12">
                                      <v-switch
                                        v-model="disableswitch"
                                        hide-details
                                        true-value="Yes"
                                        false-value="No"
                                        :label="`Disable user?: ${disableswitch}`| translate"
                                        :disabled="((currentUser.roles.includes(1) || currentUser.roles.includes(3) )? false :true )"
                                      ></v-switch>
                                    </v-col>
                                  </v-row>

                                  <v-row v-if='Object.keys(currentUser).length !=0 && (currentUser.roles.includes(1) || currentUser.roles.includes(3)) && disableswitch=="Yes"'>
                                    <v-col cols="12" sm="12" md="12">
                                      <v-menu
                                        ref="menu"
                                        v-model="menu"
                                        :close-on-content-click="false"
                                        :return-value.sync="disable_from"
                                        transition="scale-transition"
                                        offset-y
                                        min-width="auto"
                                    >
                                        <template v-slot:activator="{ on, attrs }">
                                        <v-text-field
                                            v-model="disable_from"
                                            :label="'Disable from' | translate"
                                            prepend-icon="mdi-calendar"
                                            readonly
                                            v-bind="attrs"
                                            v-on="on"
                                        ></v-text-field>
                                        </template>
                                          <v-date-picker
                                          v-model="disable_from"
                                          no-title
                                          scrollable
                                          :min="getTomorrowsDate()"
                                          >
                                          <v-spacer></v-spacer>
                                          <v-btn
                                              text
                                              :color="primary_color"
                                              @click="menu = false"
                                          >
                                              {{"Cancel" | translate}}
                                          </v-btn>
                                          <v-btn
                                              text
                                              :color="primary_color"
                                              @click="$refs.menu.save(disable_from)"
                                          >
                                              {{"OK" | translate}}
                                          </v-btn>
                                        </v-date-picker>
                                      </v-menu>
                                    </v-col>
                                  </v-row>

                                  <v-row v-if='Object.keys(currentUser).length !=0 && currentUser.roles.includes(1)'>
                                    <v-col cols="12" sm="12" md="12">
                                      <v-autocomplete
                                          v-model="roles_id"
                                          :items="userRoles"
                                          item-value="role_id"
                                          :item-text="role =>$t(role.role_name)"
                                          :label="'Roles' | translate"
                                          :rules="rolesRules"
                                          outlined
                                          chips
                                          :disabled="(currentUser.roles.includes(1)? false :true )"
                                          small-chips
                                          multiple
                                          required
                                          :no-data-text="$t('No data available')"
                                        >
                                      <template #message="{ message }">
                                        {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                                      </template>                                           
                                        </v-autocomplete>
                                    </v-col>
                                  </v-row>

                                  <v-row v-if='Object.keys(currentUser).length !=0 && (currentUser.roles.includes(1) || currentUser.permissions.includes("can-assign-custom-role"))'>
                                    <v-col cols="12" sm="12" md="12">
                                      <v-autocomplete
                                        v-model="custom_roles_id"
                                          :items="customrole"
                                          item-value="custom_role_id"
                                          item-text="custom_role_name"
                                          :label="'Custom Roles' | translate"
                                          @change="customRoleUpdated()"
                                          outlined
                                          chips
                                          small-chips
                                          multiple
                                          required
                                          :disabled="(Object.keys(currentUser).length !=0 && (currentUser.roles.includes(1) || currentUser.permissions.includes('can-assign-custom-role'))? false :true )"
                                          :no-data-text="$t('No data available')"
                                        >
                                      <template #message="{ message }">
                                        {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                                      </template>                                           
                                        </v-autocomplete>
                                    </v-col>
                                  </v-row>

                                  <v-row v-if="custom_roles_id.length>0">
                                    <v-col>
                                      <template>
                                        <v-card
                                          class="mx-auto"
                                          max-width="300"
                                          elevation="1"
                                        >
                                          <v-list dense>
                                            <v-subheader class="text-uppercase">{{ 'Permissions' | translate }}</v-subheader>
                                            <v-list-item-group
                                              color="primary"
                                            >
                                              <v-list-item
                                                v-for="(item, i) in selectedpermissions"
                                                :key="i"
                                              >
                                                <v-list-item-icon>
                                                  <v-icon color="teal">mdi-checkbox-marked-circle</v-icon>
                                                </v-list-item-icon>
                                                <v-list-item-content>
                                                  <v-list-item-title v-text="$t(item.permission_name+'-key')"></v-list-item-title>
                                                </v-list-item-content>
                                              </v-list-item>
                                            </v-list-item-group>
                                          </v-list>
                                        </v-card>
                                      </template>
                                    </v-col>
                                  </v-row>
                              </v-col>
                              </v-row>
                            </v-form>
                            <v-dialog v-model="dialog" v-if="dialog" persistent max-width="500">
                              <v-card>
                                <v-card-title class="headline" v-if='editDocument'>{{ 'Edit user document' | translate }}</v-card-title>
                                <v-card-title class="headline" v-else>{{ 'Update user document' | translate }}</v-card-title>
                                <v-card-text>
                                    <v-card-text>
                                      <v-container>
                                        <v-form id="modelform" ref="modelform">
                                          <v-row>
                                            <v-col v-if="documenterrors" cols="12" sm="12" md="12">
                                              <v-alert
                                                dense
                                                v-for="(v, k) in documenterrors"
                                                :key="k"
                                                outlined
                                                type="error"
                                              >{{ k }} {{ v }}</v-alert>
                                            </v-col>
                                          </v-row>

                                          <v-row>
                                            <v-col cols="12" sm="12" md="12">
                                              <v-autocomplete
                                                  v-model="status"
                                                  :items="statusvalues"
                                                  item-value="value"
                                                  item-text="text"
                                                  :label="'Status' | translate"
                                                  :rules="statusRules"
                                                  outlined
                                                  chips
                                                  small-chips
                                                  required
                                                  :no-data-text="$t('No data available')"
                                                >
                                                <template #message="{ message }">
                                                  {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                                                </template>
                                                </v-autocomplete>
                                            </v-col>
                                            <v-col cols="12" sm="12">
                                              <v-menu
                                                ref="menu"
                                                v-model="menu"
                                                :close-on-content-click="true"

                                                transition="scale-transition"
                                                offset-y
                                                min-width="290px"
                                              >
                                                <template v-slot:activator="{ on, attrs }">
                                                  <v-text-field
                                                    outlined
                                                    :label="'Due date' | translate"
                                                    v-model="due_date"
                                                    name="due_date"
                                                    :rules="dateRules"
                                                    autocomplete="off"
                                                    required
                                                    prepend-icon="mdi-calendar"
                                                    v-bind="attrs"
                                                    v-on="on"
                                                  >
                                                  <template #message="{ message }">
                                                    {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                                                  </template>
                                                  </v-text-field>
                                                </template>
                                                <v-date-picker
                                                  v-model="due_date"
                                                  no-title
                                                  scrollable
                                                  :locale="curLanguage.lang_code"
                                                  @input="menu=false"
                                                >
                                                </v-date-picker>
                                              </v-menu>
                                            </v-col>
                                          </v-row>

                                          <v-row v-if="formMessage != null">
                                            <v-col cols="12" sm="12" md="12">
                                              <v-alert
                                                dense
                                                outlined
                                                type="error"
                                              >{{ formMessage | translate }}</v-alert>
                                            </v-col>
                                          </v-row>

                                          <v-tabs v-if='editDocument ==false '>
                                            <v-tab @click="customForm()">{{ 'File form' | translate }}</v-tab>
                                            <v-tab v-if="showCustomForm()" @click="fileForm()">{{ 'Custom form' | translate }}</v-tab>
                                            <v-tab-item>
                                              <v-form id="fileformData" ref="fileformData">
                                              <v-row class="mt-4">
                                                  <v-col cols="12" sm="12">
                                                      <v-file-input
                                                          id="document_file"
                                                          name="filename"
                                                          outlined
                                                          chips
                                                          required
                                                          :label="'Select file' | translate"
                                                          :rules="fileRules"
                                                          @change="onFileSelectedTemplate"
                                                      >
                                                      <template #message="{ message }">
                                                          {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                                                      </template>
                                                      </v-file-input>
                                                  </v-col>  
                                                  <v-col cols="12" sm="12">
                                                    <v-textarea
                                                      outlined
                                                      name="comment"
                                                      v-model="comment"
                                                      autocomplete="off"
                                                      :label="'Comment (optional)' | translate"
                                                    >
                                                    <template #message="{ message }">
                                                      {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                                                    </template>
                                                    </v-textarea>
                                                  </v-col>
                                              </v-row>
                                              </v-form>
                                            </v-tab-item>
                                            <v-tab-item v-if="showCustomForm()">
                                              <v-form class="mt-4" id="customformData" ref="customformData">
                                                <template v-for="(data,index) in metadatakeys">
                                                  <h3 :key="index"  v-if="showCustomHeader(data)">{{ 'Page '+data }}</h3>
                                                  <v-row v-for="(metadata, indexvalue) of custommetadata[data]" :key="data+indexvalue+metadata.id">
                                                    <v-col cols="12" sm="12" md="12"  v-if ="metadata.fieldName == 'short_text' || metadata.fieldName == 'long_text' || metadata.fieldName == 'number'">
                                                      <v-text-field 
                                                          v-if ="metadata.fieldName == 'short_text'"
                                                          outlined
                                                          type="text"
                                                          :label="metadata.label"
                                                          :id="data+indexvalue"
                                                          autocomplete="off"
                                                          required
                                                          :rules="fieldRules"
                                                          @keyup="saveMetaData(data,indexvalue,data+indexvalue)"
                                                      >
                                                      <template #message="{ message }">
                                                          {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                                                      </template>                            
                                                      </v-text-field>
                                                      <v-text-field 
                                                          v-else-if ="metadata.fieldName == 'number'"
                                                          outlined
                                                          type="number"
                                                          :label="metadata.label"
                                                          :id="data+indexvalue"
                                                          autocomplete="off"
                                                          required
                                                          min="0"
                                                          :rules="fieldRules"
                                                          @keyup="saveMetaData(data,indexvalue,data+indexvalue)"
                                                      >
                                                      <template #message="{ message }">
                                                          {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                                                      </template>                            
                                                      </v-text-field>
                                                      <v-textarea
                                                        v-else-if ="metadata.fieldName == 'long_text'"
                                                        outlined
                                                        :id="data+indexvalue"
                                                        autocomplete="off"
                                                        required
                                                        :label="metadata.label"
                                                        :rules="fieldRules"
                                                        @keyup="saveMetaData(data,indexvalue,data+indexvalue)"
                                                      >
                                                      <template #message="{ message }">
                                                          {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                                                      </template>
                                                      </v-textarea>
                                                    </v-col>
                                                  </v-row>
                                                </template>
                                                <v-row>
                                                  <v-col cols="12" sm="12">
                                                    <v-textarea
                                                      outlined
                                                      name="comment"
                                                      v-model="comment"
                                                      autocomplete="off"
                                                      :label="'Comment (optional)' | translate"
                                                    >
                                                    <template #message="{ message }">
                                                      {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                                                    </template>
                                                    </v-textarea>
                                                  </v-col>
                                                </v-row>
                                              </v-form>
                                            </v-tab-item>
                                          </v-tabs>

                                          <v-row v-if="editDocument">
                                            <v-col cols="12" sm="12">
                                              <v-textarea
                                                outlined
                                                name="comment"
                                                v-model="comment"
                                                autocomplete="off"
                                                :label="'Comment (optional)' | translate"
                                              >
                                              <template #message="{ message }">
                                                {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                                              </template>
                                              </v-textarea>
                                            </v-col>
                                          </v-row>
                                        </v-form>
                                      </v-container>
                                    </v-card-text>
                                </v-card-text>
                                <v-card-actions>
                                  <v-spacer></v-spacer>
                                  <v-btn color="green darken-1" text @click="closeBox">{{ 'Close' | translate }}</v-btn>
                                  <v-btn color="green darken-1" v-if="editDocument" text @click='editPersonalDocument()'>{{ 'Update' | translate }}</v-btn>
                                  <v-btn color="green darken-1" v-else text @click='uploadDocument'>{{ 'Upload' | translate }}</v-btn>
                                </v-card-actions>
                              </v-card>
                            </v-dialog>
                            <v-btn
                              dark
                              fab
                              fixed
                              bottom
                              right
                              large
                              color="pink"
                              class="mx-2"
                              v-if="user_id != '' && Object.keys(currentUser).length !=0 && currentUser.roles.includes(1)"
                              @click="submit"
                            >
                              <v-icon>mdi-content-save</v-icon>
                            </v-btn>
                            <v-btn
                              dark
                              fab
                              fixed
                              bottom
                              right
                              large
                              color="pink"
                              class="mx-2"
                              v-if="user_id && Object.keys(currentUser).length !=0 && ((currentUser.roles.includes(1) || currentUser.roles.includes(3)) || currentUser.permissions.includes('can-assign-custom-role'))"
                              @click="update"
                            >
                              <v-icon>mdi-content-save</v-icon>
                            </v-btn>
                          </v-card-text>
                            
                        </v-card>
                    </v-tab-item>  
                    <v-tab-item value="viewUserDocuments">
                        <v-card flat> 
                          <v-row v-if="user_id !== null ">
                            <v-col cols="12">
                              <v-tabs
                                v-model="tabs"
                                fixed-tabs
                              >
                                <v-tabs-slider></v-tabs-slider>
                                <v-tab
                                  href="#userdocuments"
                                  class="primary--text"
                                >
                                  {{ 'User documents' | translate}}
                                </v-tab>

                                <v-tab
                                  href="#certifications"
                                  class="primary--text"
                                >
                                  {{ 'Certifications' | translate }}
                                </v-tab>

                              </v-tabs>

                            <v-tabs-items v-model="tabs">
                              <v-tab-item value="userdocuments"> 
                                  <v-data-table
                                    :headers="personaldocumentheaders"
                                    :items="personaldocuments"
                                    :single-expand="singleExpand"
                                    :expanded.sync="expanded"
                                    item-key="temp_name"
                                    show-expand
                                    class="elevation-1"
                                    :footer-props="{ 'items-per-page-text': footertext, 'itemsPerPageOptions':[5,10,20,{ text: $t('All'), value: -1 }]   }"
                                  >
                                    <template slot="no-data">
                                        {{ 'No data available' | translate }}
                                    </template>
                                      <template v-slot:footer.page-text="items"> 
                                        {{ items.pageStart }} - {{ items.pageStop }} {{ 'of' | translate}} {{ items.itemsLength }} 
                                      </template>                          
                                    <template v-slot:item.template ="{ item }" >
                                        <v-btn class="white--text" small :color="primary_color" v-on:click="downloadUserTemplate(item.temp_files[0])">{{ 'View Template' | translate }}</v-btn>
                                    </template>   
                                    <template v-slot:item.update ="{ item }" >
                                        <v-btn class="white--text" small :color="primary_color" v-on:click="openDialog(item.temp_files[0].temp_id, item.temp_validity, item.temp_type, item.temp_files)" >{{ 'Update document'| translate }}</v-btn>
                                    </template>  
                                      <template v-slot:item.data-table-expand="{ item ,expand, isExpanded }">
                                        <v-icon v-if="!isExpanded" @click="expand(!isExpanded); showUserDocuments(item.temp_files[0].temp_id)">mdi-chevron-down</v-icon>
                                        <v-icon v-if="isExpanded" @click="expand(!isExpanded)">mdi-chevron-up</v-icon>
                                      </template>
                                    <template v-slot:top>
                                      <v-card-title>
                                      </v-card-title>
                                      <v-toolbar  flat color="white">
                                        <v-spacer></v-spacer>
                                        <v-text-field v-model="searchuserdocuments" append-icon="search" :label="'Search' | translate" single-line hide-details></v-text-field>
                                      </v-toolbar>
                                    </template>
                                    <template v-slot:expanded-item="{ headers }">
                                      <td :colspan="headers.length" style='padding: 0px !important;'>
                                      <v-data-table
                                        :headers="subdocumentheaders"
                                        :items="userdocuments"
                                        item-key="created_at"
                                        class="elevation-1"
                                        hide-default-footer
                                        disable-pagination
                                      >
                                      <template slot="no-data">
                                          {{ 'No data available' | translate }}
                                      </template>
                                      <template v-slot:footer.page-text="items"> 
                                        {{ items.pageStart }} - {{ items.pageStop }} {{ 'of' | translate}} {{ items.itemsLength }} 
                                      </template>
                                      <template v-slot:item.view ="{ item }">
                                          <v-btn class="white--text" small :color="primary_color"  v-on:click="downloadUser(item.ud_id, item.updated_at, item.extension)">{{ 'View'| translate }}</v-btn>
                                      </template>  
                                      <template v-slot:item.edit ="{ item }">
                                          <v-btn class="white--text" small :color="primary_color" v-on:click="openeditDialog(item.ud_id,item.temp_id,item.due_date, item.status, item.hasOwnProperty('comment') ? item.comment: '')">{{ 'Edit'| translate }}</v-btn>
                                      </template> 
                                      </v-data-table> 
                                      </td>                           
                                    </template>
                                  </v-data-table>
                              </v-tab-item>  
                              <v-tab-item value="certifications">
                                <DataTable
                                  title=""
                                  :headers="certificateheaders"
                                  :items="usercertificates"
                                  :search="searchcertificate"
                                /> 
                              </v-tab-item>    
                            </v-tabs-items>                
                            </v-col>
                          </v-row>
                        </v-card>
                    </v-tab-item>  
                    <v-tab-item value="viewUserActivity">
                      <v-row class="pl-10">
                        <v-col cols="3">
                          <v-select
                            v-model="filterItem"
                            :items="filterItems"
                            item-value="value"
                            item-text="text"
                            :label="'Filter By' | translate"
                            @change="filterUpdated()"
                            multiple
                            outlined
                          ></v-select>
                        </v-col>
                        <v-col cols="3">
                          <v-switch class="ml-3"
                            v-model="inverse"
                            :label="'Inverse Timeline' | translate"
                          ></v-switch>
                        </v-col>
                      </v-row>
                        <v-card flat v-if="userlog.length"> 
                          <v-card-text style="padding:50px;">
                            <template>
                              <v-timeline
                                align-top
                                :reverse="reverse"
                                :dense="$vuetify.breakpoint.smAndDown"
                              >

                                <v-timeline-item
                                  v-for="(userlogdetails, userlogindex) in (FilteredItems.length>0?FilteredItems:userlog)"
                                  :key="userlogindex"
                                  :color="userlogdetails.color"
                                  :icon="userlogdetails.icon"
                                  fill-dot
                                >
                                  
                                  <v-expansion-panels accordion>
                                  <v-expansion-panel>
                                    <v-card
                                      :color="userlogdetails.color"
                                      dark
                                    >
                                    <v-expansion-panel-header>
                                      <template v-slot:actions>
                                        <v-icon color="white">
                                          $expand
                                        </v-icon>
                                      </template>
                                      <v-card-title class="pa-0">
                                        <v-row
                                          align="center"
                                          class="mx-0"
                                        >
                                          <div class="text-h6">{{userlogdetails.name | translate}}</div>

                                          <div class="white--text subtitle-2 font-weight-medium ms-9">
                                            {{getDate(userlogdetails.stored_at)}}
                                          </div>
                                        </v-row>
                                      </v-card-title>
                                    </v-expansion-panel-header>
                                    
                                    <v-expansion-panel-content>
                                      <v-card-text class="white text--primary pt-3">
                                        <!-- <p>{{userlogdetails.description}}</p> -->

                                           <div
                                             v-for="(metaval, metakey) in userlogdetails.full_meta_data" 
                                             :key="metakey"
                                            >
                                            <v-row>
                                              <v-col class="flex-child-element">
                                                <v-tooltip max-width="300" bottom>
                                                  <template v-slot:activator="{ on, attrs }">
                                                    <div
                                                      v-bind="attrs"
                                                      v-on="on"
                                                    ><b class="module-key">{{ userlogdetails.log_type+'.'+userlogdetails.statement_query+'.'+metakey+'.key'| translate }}</b> :</div>
                                                  </template>
                                                  <div><b>{{ userlogdetails.log_type+'.'+userlogdetails.statement_query+'.'+metakey+'.description'| translate }}</b></div>
                                                </v-tooltip>
                                                <template v-if="isHTML(extractVal(metaval))">
                                                    <div v-html="extractVal(metaval)"></div>
                                                </template>
                                                <template v-else>
                                                  {{extractVal(metaval) | translate}}
                                                </template>
                                              </v-col>
                                              </v-row>
                                            </div>
                                          
                                            <div
                                            class="flex-parent-element"
                                             v-for="(metaval, metakey) in userlogdetails.half_meta_data" 
                                             :key="metakey"
                                            >
                                              <v-row class="flex-child-element" >
                                                 <v-col v-for="(metav, metak) in metaval" 
                                                  :key="metak">

                                                  <v-tooltip max-width="300" bottom>
                                                    <template v-slot:activator="{ on, attrs }">
                                                      <div
                                                        v-bind="attrs"
                                                        v-on="on"
                                                      ><b class="module-key">{{ userlogdetails.log_type+'.'+userlogdetails.statement_query+'.'+metak+'.key'| translate }}</b>:</div>
                                                    </template>
                                                      <div>{{ userlogdetails.log_type+'.'+userlogdetails.statement_query+'.'+metak+'.description'| translate }}</div>
                                                  </v-tooltip>
                                                   {{ extractVal(metav) }}
                                                 </v-col>
                                              </v-row>
                                            </div>

                                              
                                        <v-chip-group column mandatory>
                                          <v-chip :color="userlogdetails.color" outlined @click="addFilter(userlogdetails.log_type)">
                                            {{sanitizeVal(userlogdetails.log_type) | translate}}
                                          </v-chip>
                                          <!-- <a class="v-chip v-chip--active v-chip--clickable" style="text-decoration: underline; color: #1976d2;" @click="openDetailedModuleModal(userlogdetails)" >{{'View Details' | translate}}</a> -->
                                        </v-chip-group> 


                                      </v-card-text>
                                    </v-expansion-panel-content>
                                  </v-card>
                                  </v-expansion-panel>  
                                  </v-expansion-panels>
                                  
                                </v-timeline-item>
                              </v-timeline>
                            </template>
                          </v-card-text>
                        </v-card>
                        <v-card v-else>
                          <v-card-text>
                            {{'No Activity to Show' | translate}}
                          </v-card-text>
                        </v-card>
                    </v-tab-item> 
                      <v-tab-item value="viewUserStats" class="pa-6">
                        <div  v-if="filtereduserstats">
                          <div v-for="(userStats , index) in filtereduserstats" :key="index" class="my-12" >
                          <v-toolbar-title class="grey--text text--darken-4 text-center font-weight-bold">
                              {{userStats.name}}
                              </v-toolbar-title>
                              
                              <div class="d-flex flex-wrap"> 
                                  <template>
                                  <SimpleCard type="CoursesSubscribed" title="Courses Subscribed" description="Number of Courses Subscribed" color="blue" :totalcount="userStats.no_courses_sub"/>
                                  <SimpleCard type="CoursesActive" title="Active Courses" description="Number of Active Courses" color="green" :totalcount="userStats.no_acitve_courses"/>
                                  </template>
                              </div>
                      

                              <div class="row" >
                                      <div class="col" >
                                      <v-card 
                                          height="520"
                                      >
                                          <template>
                                          <v-carousel
                                              show-arrows-on-hover
                                          height="520"

                                          >
                                              <v-carousel-item
                                              v-for="(slide, i) in slides"
                                              :key="i"
                                              >
                                              <v-card-title> {{slide.name}} </v-card-title>
                                              <v-sheet
                                                  color="white"
                                                  height="100%"
                                              >
                                                  <v-row
                                                  class="ma-1"
                                                  align="center"
                                                  justify="center"
                                                  >
                                                  <template v-if="slide.type=='Bar'">
                                                      <BarChart :chart-data="convertBarChart('chartData',userStats.learn_progress)" :chart-options="convertBarChart('chartOptions',userStats.learn_progress)"
                                                      />
                                                  </template>
                                                  <template v-if="slide.type=='Doughnut'">
                                                      <DoughnutChart :chart-data="convertDoughnutChart('chartData',userStats.pass_percentage)" :chart-options="convertDoughnutChart('chartOptions',userStats.pass_percentage)"
                                                      />
                                                  </template>
                                                  
                                                  </v-row>
                                              </v-sheet>
                                              </v-carousel-item>
                                          </v-carousel>
                                          </template>
                                      </v-card>
                                      </div>
                              
                              <div class="col-md-auto" v-if="userStats.courses.length">
                                  <template>
                                  <v-card
                                      class="mx-auto overflow-auto"
                                      max-width="400"
                                      height="520"
                                  >
                                      <v-toolbar
                                      :color="primary_color"
                                      dark
                                      style="position: sticky;
                                      top: 0;
                                      z-index: 999;"
                                      >
                                      <v-toolbar-title>{{ "Courses" | translate}}</v-toolbar-title>
                                      </v-toolbar>

                                          <v-list two-line>
                                              <v-list-group
                                              v-for="(item, index) in userStats.courses"
                                              :key="index"
                                              v-model="item.active"
                                              :prepend-icon="item.action"
                                              no-action
                                              >
                                              <template v-slot:activator>
                                                  <v-list-item-content>
                                                      <v-list-item-title v-text="item.course_name"></v-list-item-title>
                                                      <v-list-item-action-text
                                                          :class="item.active ? 'text-blue':'text--primary'"
                                                      > 
                                                      {{'Course Progress' | translate}} <b>{{item.course_progress}}% </b></v-list-item-action-text>
                                                      <v-progress-linear
                                                        :value="item.course_progress"
                                                        color="green"
                                                      ></v-progress-linear>
                                                      <v-list-item-action-text v-if="item.course_ends_on">{{'Ends' |translate}} : {{convertDate(item.course_ends_on)}}  </v-list-item-action-text>
                                                  </v-list-item-content>
                                                  <v-list-item-action>
                                                      <v-list-item-action-text>{{item.modules.length}} Modules</v-list-item-action-text>
                                                      <v-icon :class="item.active ? 'text-blue':'text-grey'"> mdi-file </v-icon>
                                                     </v-list-item-action>
                                              </template>

                                              <v-card elevation="5" class="pa-2 pb-6 mb-2"> 
                                                  <template>
                                                      <div v-for="(moduleItem , moduleIndex) in item.modules" :key="moduleIndex">
                                                          <ModuleCard :width="100" color="grey" :value="moduleItem" />
                                                      </div>
                                                  </template>
                                              </v-card>

                                              </v-list-group>
                                          </v-list>

                                  </v-card>

                                  </template>
                              </div>
                              
                              </div>
                         
                          </div>
                        </div>
                        <div v-else>
                          {{'No data to show' | translate}}
                        </div>
                    </v-tab-item>  
                    
                </v-tabs-items>   
              </v-card>

              <UserLogDetailView
                @closeMetaView="closeMetaView"
                :userlogdetailview="userlogdetailview"
                :userlogdetails="userlogdetails"
                v-if="userlogdetailview"
              />
              
            </v-container>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-content>
</template>
<style lang="scss">
.v-data-footer {
  -webkit-box-pack: start !important;
  -ms-flex-pack: start !important;
  justify-content: flex-start !important;
  -webkit-box-align: center !important;
  -ms-flex-align: center !important;
  align-items: center !important;
}

.v-application--is-ltr .v-data-footer__select {
  margin-left: 16px !important;
}
</style>

<script>
import {
  ADD_USER,
  FETCH_USERS,
  FETCH_GROUPS,
  FETCH_ROLES,
  FETCH_CUSTOM_ROLE,
  RESET_STATE,
  FETCH_INDIVIDUAL_USER,
  FETCH_USER_DOCUMENTS,
  DOWNLOAD_PERSONAL_DOCUMENT,
  DOWNLOAD_USER_DOCUMENT,
  UPDATE_USER_DOCUMENT,
  FETCH_PERSONAL_DOCUMENTS,
  FETCH_USER_CERTIFICATES,
  UPDATE_USER,
  FETCH_PERMISSIONS,
  FETCH_USER_LOG,
  FETCH_USER_STATS,
} from "@/store/actions.type";
import {  SET_SNACKBAR, SET_LOADING, SET_ROUTER_ENTER, SET_USER_DOCUMENTS, SET_DOCUMENTS_ERROR } from "@/store/mutations.type";
import store from "@/store";
import { mapState } from "vuex";
import { mapGetters } from "vuex";
export default {
  name: "AddEditUser",
  async beforeRouteEnter(to, from, next) {
    Promise.all([
      store.dispatch(RESET_STATE),
       store.dispatch(FETCH_USERS, ''),
      ((store.getters.currentUser.roles.includes(1))?store.dispatch(FETCH_GROUPS, ''): ''),
      (store.getters.currentUser.roles.includes(1)?store.dispatch(FETCH_ROLES, ''):''),
      ((store.getters.currentUser.roles.includes(1) || store.getters.currentUser.permissions.includes("can-assign-custom-role") )?store.dispatch(FETCH_CUSTOM_ROLE, ''):''),
      (to.params.id ? store.dispatch(FETCH_INDIVIDUAL_USER, to.params.id) : ''),
      (to.params.id ? store.dispatch(FETCH_PERSONAL_DOCUMENTS, '?user_id='+to.params.id) : ''),
      (to.params.id ? store.dispatch(FETCH_USER_CERTIFICATES, 'course-certificates?user_id='+to.params.id) : ''),
      ((to.params.id && (store.getters.currentUser.roles.includes(1) || store.getters.currentUser.roles.includes(3) || store.getters.currentUser.permissions.includes('can-audit-user-history') )) ? store.dispatch(FETCH_USER_LOG,to.params.id) : ''),
    ]).finally(() => {
      store.commit(SET_LOADING, false)
      store.commit(SET_ROUTER_ENTER, false)
    });


    return next();
  },
  components: {
    DataTable: () => import("@/components/datatable/datatable"),
    UserLogDetailView: () => import("@/components/modal/UserLogDetailView"),
    BarChart: () => import("@/components/charts/Bar"),
    DoughnutChart: () => import("@/components/charts/Doughnut"),
    SimpleCard: () => import("@/components/cards/SimpleCard"),
    ModuleCard: () => import("@/components/cards/ModuleCard"),
  },  
  data: function() {
    return {
      maintabs: null,
      panelState:null,
      tabs: null,
      name: "",
      email: "",
      address: "",
      selectedLanguage: "",
      phone_no: "",
      salutation: "",
      searchuserdocuments:'',
      searchcertificate: '',
      user_id: null,
      roles_id:[],
      custom_roles_id:[],
      doc_id: null,
      due_date: null,
      status: null,
      comment: null,
      personaldocumentid: null,
      file: null,
      group_admins: [],
      editDocument: false,
      expanded: [],
      dialog: false,
      singleExpand: true,
      groups_id:[],
      temp_type: null,
      primary_color: null,
      menu: false,
      custommetadata: {},
      filetemplate: null,
      metadatakeys:[],
      datacustom: {},
      formMessage: null,
      customFormStatus: false,
      selectedpermissions:null,
      reverse:true,
      inverse:false,
      filterItem:null,
      filterItems:[
          { value:'permission', text: this.$t('Permission')},
          { value:'module', text: this.$t('Module')},
          { value:'quiz', text: this.$t('Quiz')},
          { value:'group', text: this.$t('Group')},
          { value:'course', text: this.$t('Course')},
        ],
      FilteredItems: [],
      userlogdetailview:false,
      userlogdetails:null,
      filtereduserstats:null,
      disableswitch:'No',
      disable_from: null,
        //carousel for slides
      slides: [
        {
          'name' : this.$t('Pass Percentage of currently Subscribed Courses'),
          'type' : 'Doughnut',
        },
        {
          'name' : this.$t('Status of learning progress'),
          'type' : 'Bar',
        },
      ],

    };
  },
  computed: {
    ...mapGetters(['individualuser', 'roles', 'customrole', 'groups', 'personaldocuments', 'userdocuments','currentUser','curLanguage', 'usercertificates','userlog','userstats','languages']),
    statusvalues(){ 
      return [
        { value: "active", text: this.$t("Active") },
        { value: "inactive", text: this.$t("Inactive") },
      ]
    },  
    emailRules(){ 
      return [v => /.+@.+/.test(v) || "Invalid Email address"]
    },
    numberRules(){ 
      return [
      v => !!v || "Phone Number is required",
      v => Number.isInteger(Number(v)) || "The value must be an integer number"
      ]
    },
    salutationRules(){ 
      return [v => !!v || "Title is required",
      (v) =>  (v && v.length <= 20) || "Title must be less than 20 characters"
      ] 
    },
    addressRules(){
      return [v => !!v || "Address is required"]
    },
    rolesRules(){ 
      return [v => !!(v && v.length) || "Role is required"]
    },
    groupsRules(){ 
      return [v => !!v || "Groups are required"]
    },
    statusRules(){ 
      return [v => !!v || "Status is required"]
    },
    dateRules(){ 
      return [v => !!v || "Date is required"]
    },
    salutationvalues(){
      let salutationData = [
        { value: "Mr", name: this.$t("Mr") },
        { value: "Mrs", name: this.$t("Mrs") }
      ]
      return salutationData
    },
    fieldRules() {return [v => !!v || "Field is required"]},
    fileRules() {return [
      v => !!v || 'File is required',
      v => (v && v.size > 0) || 'File is required',
    ]},
    nameRules(){
      let namerule = [(v) => !!v || "Name is required"]
      return namerule
    },  
    footertext(){
      return this.$t('Rows per page')
    },    
    ...mapState({
      errors: state => state.users.usererrors,
      documenterrors: state => state.documents.documenterrors
    }),
    userRoles(){
      if((this.individualuser).length !=0){ // edit user group page if individual user exists
        if(this.individualuser.roles.includes(6)){
        //check if it is an external user, change roles accordingly
          return this.roles.filter(data=>data.role == 'external-user')
        }
      }
      //default for users
      return this.roles.filter(data=>data.role != 'group-admin' && data.role != 'auditor'  && data.role != 'external-user')
    },
    personaldocumentheaders(){
      return  [
        { text: this.$t('User document name'), value: "temp_name" },
        {text: this.$t('Days until'), value: "temp_validity"},
        {text: this.$t('Template'), value:'template'},
        {text: this.$t('Update'), value:'update'},
        { text: '', value: 'data-table-expand' },
      ]
    },
    certificateheaders(){
      return  [
        { text: this.$t('Course name'), value: "course_name" },
        {text: this.$t('Completed on'), value: "passed_on"},
        { text: this.$t('View'), value: 'view_certificate' },
      ]
    },
    subdocumentheaders(){
      return [
        { text: this.$t("Status"), value: "status" },       
        { text: this.$t("Due date"), value: "due_date" },  
        { text: this.$t("Uploaded by"), value: "uploaded_user" },  
        { text: this.$t("Uploaded on"), value: "created_at" },
        { text: this.$t('Edit'), value: 'edit' },
        { text: this.$t('View'), value: 'view' },
      ]
    },
    languagesdata(){
      return this.languages.map(data =>{
        return{
         'lang_code': data.lang_code,
         'lang_id':  data.lang_id,
         'lang_name': this.$t(data.lang_name),
        }
     
      })
    }
  },
  watch: {
    individualuser(value) {
      if(Object.keys(value).length>0){
        this.renderData()
      }
    },
    inverse(){
      this.FilteredItems = (this.FilteredItems.length>0) ? (this.FilteredItems.slice().reverse()) : (this.userlog.slice().reverse());
    },
    disableswitch(){
      if(this.disableswitch=='No'){
        this.disable_from = null;
      }
    }

  },
  created () {
    let company_meta  = JSON.parse(this.currentUser.company.company_meta)
    this.primary_color  = company_meta.primary_color
  },
  mounted(){
    this.selectedLanguage = process.env.VUE_APP_DEFAULT_LANGUAGE ? process.env.VUE_APP_DEFAULT_LANGUAGE : 'de'
  },
  methods: {
    closeallpanels(){
      this.panelState = null
    },
    saveMetaData(index,internalindexvalue, id) {
      const value = document.getElementById(id).value
      this.custommetadata[index][internalindexvalue].value = value
    },
    fileForm() {
      this.formMessage = null
      document.getElementById('document_file').value=''
      this.comment=''
      this.$refs.fileformData.reset()
      if(this.$refs.customformData != undefined) {
        this.$refs.customformData.reset()
      }
    },
    getTomorrowsDate(){
      var date = new Date();
      let day = String(date.getDate()+1).padStart(2, '0');
      let month = String(date.getMonth() + 1).padStart(2, '0'); //January is 0!
      let year = date.getFullYear();
      return `${year}-${month}-${day}`;
    },
    customForm () {
      this.formMessage = null
      this.comment = ''
      document.getElementById('document_file').value=''
      this.$refs.fileformData.reset()
      this.$refs.customformData.reset()
    },
    showCustomForm () {
      let status = false
      for(let data in this.custommetadata) {
        this.custommetadata[data].forEach(metadata => {
          if(metadata.fieldName == 'short_text' || metadata.fieldName == 'long_text' || metadata.fieldName == 'number') {
            status = true
          }
        })
      }
      return status
    },
    showCustomHeader(customkey) {
      let status = false
      this.custommetadata[customkey].forEach(metadata =>{
        if(metadata.fieldName == 'short_text' || metadata.fieldName == 'long_text' || metadata.fieldName == 'number'){
          status =true
        }
      })
      return status
    },
    onFileSelectedTemplate() {
      this.filetemplate = document.getElementById("document_file").files[0];
    },
    gotoUsers() {
      this.$router.push({ name: "users" });
    },  
    onFileSelected() {
      this.file = document.getElementById("document_file").files[0];
    }, 
    convertDate(dateString){
        const options = { year: "numeric", month: "long", day: "numeric" }
        return new Date(dateString).toLocaleDateString(this.currentUser.lang_code, options)
    },     
    renderData() {
      this.name = this.individualuser.name;
      this.email = this.individualuser.email;
      this.phone_no = this.individualuser.phone_no;
      this.selectedLanguage = this.individualuser.lang_code;
      this.address = this.individualuser.address;
      this.salutation = this.individualuser.salutation;
      this.user_id = this.individualuser.user_id;
      if(this.individualuser.disable_from){
        this.disableswitch = 'Yes'
        this.disable_from = this.individualuser.disable_from;
      }
      else{
        this.disableswitch = 'No'
        this.disable_from = null;
      }
      this.roles_id =  this.individualuser.roles
      if(this.currentUser.permissions.includes('can-assign-custom-role') || this.currentUser.roles.includes(1)){
        this.custom_roles_id =  this.individualuser.custom_roles
        store.dispatch(FETCH_PERMISSIONS, "?custom_role_ids=" + this.custom_roles_id)
          .then((resp) => {
            this.selectedpermissions = resp.data;
        });
      }

    }, 
    downloadUserTemplate(documentdata){
      this.$store
        .dispatch(DOWNLOAD_PERSONAL_DOCUMENT, 'view-file/'+documentdata.temp_id)
        .then(resp => {
            var byteCharacters = atob(resp.data);
            var byteNumbers = new Array(byteCharacters.length);
            for (var i = 0; i < byteCharacters.length; i++) {
              byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            var byteArray = new Uint8Array(byteNumbers);

          var fileURL = window.URL.createObjectURL(new Blob([byteArray],{type: 'application/pdf'}));
          var fileLink = document.createElement('a');
          fileLink.href = fileURL;
          fileLink.setAttribute('download', documentdata.updated_at+'.'+documentdata.extension);
          document.body.appendChild(fileLink);
          fileLink.click();
          this.$store.commit(SET_LOADING, false);
        });
    },
    async downloadUser(id, name , extension){
      await this.$store
        .dispatch(DOWNLOAD_USER_DOCUMENT, 'view-file/'+id)
        .then(resp => {
          var fileURL = window.URL.createObjectURL(new Blob([resp]));
          var fileLink = document.createElement('a');
          fileLink.href = fileURL;
          fileLink.setAttribute('download', name+'.'+extension);
          document.body.appendChild(fileLink);
          fileLink.click(); 
          store.commit(SET_LOADING, false);

        });
    },
    openDialog(id, days, type, files){
      this.metadatakeys = Object.keys(JSON.parse(files[0].temp_meta_data))
      this.custommetadata = JSON.parse(files[0].temp_meta_data)
      var currentDate = new Date()
      var validdate = new Date()
      validdate.setDate(currentDate.getDate()+days)
      this.dialog= true
      this.doc_id = id
      this.file=  null
      this.comment  = null
      this.due_date = validdate.toISOString().slice(0,10)
      this.status = null
      this.temp_type = type
    },
    openeditDialog(udid, idpersonaldocument,  duedate, status, comment){
      this.dialog= true
      this.doc_id = udid
      this.file=  null
      this.personaldocumentid = idpersonaldocument
      this.comment  = comment != undefined ? comment : ''
      this.due_date = duedate
      this.status = status
      this.editDocument = true
    },    
    closeBox(){
      if(!this.editDocument) {
        document.getElementById('document_file').value=''
      }
      document.getElementById("modelform").reset();
      this.dialog = false
      this.editDocument = false
      this.formMessage = null
      this.$store.commit(SET_DOCUMENTS_ERROR, [])
    },
    async showUserDocuments(tempid){
      this.$store.commit(SET_USER_DOCUMENTS, [])
      await this.$store.dispatch(FETCH_USER_DOCUMENTS,'?item_id='+this.individualuser.user_id+'&temp_id='+tempid+'&inbox_filter=false').then(resp=>{
        if (resp != undefined && resp.hasOwnProperty('success') && resp.success) {
          this.$store.commit(SET_LOADING, false)
        }
        else{
          this.$store.commit(SET_LOADING, false)
        }
      })
    },
    async editPersonalDocument(){
      if (this.$refs.modelform.validate()) {
          var formData = new FormData(document.getElementById("modelform"));
          formData.set("item_id", this.individualuser.user_id)
          formData.set("temp_id", this.personaldocumentid)
          formData.set('status', this.status)
          formData.set('due_date', this.due_date)
          formData.set('comment', this.comment)
          formData.set('ud_id', this.doc_id)
          formData.set('_method', 'put')
          this.$store.dispatch(UPDATE_USER_DOCUMENT, formData).then(async resp => {
            if (resp !==undefined && resp.success) {
                  await this.showUserDocuments(this.personaldocumentid)
                  store.commit(SET_SNACKBAR, {status: true, message: 'User document updated successfully'})
                  this.dialog =false
                  this.doc_id = null
                  this.file=  ''
                  this.comment  = ''
                  this.due_date = ''
                  this.status = ''
                  this.editDocument = false
                  this.personaldocumentid = null 
                  this.$refs.modelform.reset()              
                  store.commit(SET_LOADING, false)

            }
            else if(resp !==undefined && !resp.success){
              store.commit(SET_LOADING, false)
            }
          });

    
      }
    },    
    async uploadDocument(){
      if (this.$refs.modelform.validate()) {
          if(( this.$refs.customformData !=undefined  && this.$refs.customformData.validate()) || (this.$refs.fileformData !=undefined && this.$refs.fileformData.validate())) { 
            this.formMessage = null
          }
          else {
            this.formMessage = "Please fill custom form or file form completely"
            return ;             
          }

          var formData = new FormData(document.getElementById("modelform"));
          
          if(this.filetemplate != null && this.filetemplate != undefined && this.filetemplate != '') {
            formData.set("file", this.filetemplate)
          }
          else {
            formData.delete("file")
          }
          
          formData.set("item_id", this.user_id)
          formData.set("temp_id", this.doc_id)
          formData.set('status', this.status)
          formData.set('due_date', this.due_date)
          formData.set('comment', this.comment)
          if(this.filetemplate == null || this.filetemplate == undefined || this.filetemplate == '')
          formData.set('temp_meta_data',JSON.stringify(this.custommetadata))
          
          this.$store.dispatch(UPDATE_USER_DOCUMENT, formData).then(async resp => {
            if (resp !==undefined && resp.success) {
                  await this.showUserDocuments(this.doc_id)
                  this.$store.commit(SET_SNACKBAR, {status: true, message: 'User document updated successfully'})
                  this.$refs.modelform.reset()
                  this.dialog =false
                  this.doc_id = null
                  this.file=  null
                  this.comment  = null
                  this.due_date = null
                  this.status = null
                  this.editDocument = false
                  this.personaldocumentid = null                
                  store.commit(SET_LOADING, false)

            }
            else if(resp !==undefined && !resp.success){
              store.commit(SET_LOADING, false)
            }
          });
      }
    },
    async customRoleUpdated() {
      await store
        .dispatch(FETCH_PERMISSIONS, "?custom_role_ids=" + this.custom_roles_id)
        .then((resp) => {
          this.selectedpermissions = resp.data;
        });
    },
    getDate(dateString){
        const options = { year: "numeric", month: "long", day: "numeric",  hour: "numeric", minute: "numeric", second: "numeric", }
        return new Date(dateString).toLocaleDateString(this.currentUser.lang_code, options)
    },
    submit: function() {
      if (this.$refs.form.validate()) {
        this.$store
          .dispatch(ADD_USER, {
            email: this.email,
            name: this.name,
            lang_code :this.selectedLanguage,
            address: this.address,
            phone_no: this.phone_no,
            salutation: this.salutation,
            roles: this.roles_id,
            custom_roles: this.custom_roles_id, 
          })
          .then(resp => {
            if (resp != undefined && resp.hasOwnProperty('success') && resp.success) {
              store.commit(SET_SNACKBAR, {status: true, message: 'User created successfully'})
              store.commit(SET_LOADING, false)
              this.$router.push({ name: "users" });
            }
            else{
              store.commit(SET_LOADING, false)
            }
          });
      }
    },
    update: function() {
      if (this.$refs.form.validate()) {
        this.$store
          .dispatch(UPDATE_USER, {
            email: this.email,
            name: this.name,
            lang_code :this.selectedLanguage,
            address: this.address,
            phone_no: this.phone_no,
            salutation: this.salutation,
            user_id: this.user_id,
            disable_from:this.disable_from,
            status:this.disable_from?'active':'active',
            roles: this.roles_id, 
            custom_roles: this.custom_roles_id, 
            _method: "put"
          })
          .then(resp => {
            if (resp != undefined && resp.hasOwnProperty('success') && resp.success) {
              store.commit(SET_SNACKBAR, {status: true, message: 'User updated successfully'})
              store.commit(SET_LOADING, false)
              this.$router.push({ name: "users" });
            }
            else{
              store.commit(SET_LOADING, false)
            }

          });
      }
    },
    filterUpdated(){
      this.FilteredItems = this.userlog.filter(item => this.filterItem.includes(item.log_type) );
    },
    addFilter(log_type){
      this.filterItem = []; 
      this.filterItem.push(log_type);
      this.FilteredItems = this.userlog.filter(item => this.filterItem.includes(item.log_type) );
    },
    sanitizeVal(val){
      if (val !== null && typeof val === 'string' && val.length > 0) {
        return (val.charAt(0).toUpperCase() + val.slice(1)).replace(/([A-Z])/g, ' $1').trim();
      }
      return val;
    },
    isHTML(str) {
      var a = document.createElement('div');
      a.innerHTML = str;

      for (var c = a.childNodes, i = c.length; i--; ) {
        if (c[i].nodeType == 1) return true; 
      }

      return false;
    },
    extractVal(val) {
      let result = '';
      if(typeof val === 'object' && !Array.isArray(val) && val !== null){
        Object.keys(val).forEach(key => {
          result =  (key, val[key]) +', '+ result;
        });
      }
      else if(Array.isArray(val)){
        for (const prop in val) {
            const value = val[prop];
            if (typeof value === 'object') {
                result = (this.extractVal(value)) +', '+ result; // <- recursive call
            }
            else {
                result = this.$t(value) +', '+ result;
            }
        }
      }
      else{
        result = val;
      }
      
      if (result !== null && typeof result === 'string' && result.length > 0) {
          result = result.charAt(0).toUpperCase() + result.slice(1);
      }
      
      return result;
    },
    openDetailedModuleModal(userlogdetails){
        this.userlogdetailview = true;
        this.userlogdetails = userlogdetails;
      
    },
    closeMetaView(){
      this.userlogdetailview = false
    },
    async fetchUserStats(){
        if(!this.filtereduserstats){
          await store.dispatch(FETCH_USER_STATS, '?user_ids='+this.user_id).then(resp => {
              if (resp.success) {
                this.filtereduserstats = this.userstats.users_data;
              }
          });
        }
    },
    convertModuleDoughnutChart(option,data){
      if(option=='chartData'){
        let chartData = {
          labels: [this.$t('Started'), this.$t('Not Started'), this.$t('Finished')],
          datasets: [
            {
              backgroundColor: ['#2471A3','#D4AC0D','#196F3D'],
              data: [data.started, data.not_started, data.finished]
            }
          ]
        }
        return chartData;
      }
      else{
        let chartOptions = {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
              title: {
                display: true,
                text: this.$t("Subscribed Users Learning Status")
              },
              legend: {
                  display: true,
                  position: 'bottom',
              }
          }
        }
        return chartOptions;
      }
    },
    changedFilter(){
      if(!this.selectedCourses.length){
          this.filtereduserstats = this.userstats;
      }
      else{
        this.filtereduserstats = this.userstats.filter(v => this.selectedCourses.includes(v.course_id));  
      }
      
    },

    convertBarChart(option, data){
      if(option=='chartData'){
        let datalabels = Object.keys(data);
        let datavalues = Object.values(data);
        let chartData = {
          labels: datalabels,
          datasets: [{
                label: this.$t("Number of Courses"),
                data: datavalues,
                backgroundColor: ["#c4e5ff","#E46651","#F7DC6F","#48C9B0","#138D75"],
                barThickness: 15,
          }]
        }
        return chartData;
      }
      else{
        let chartOptions = {
            responsive: true,
            maintainAspectRatio: false,
            scales: {
                x: {
                  title:{
                      display: true,
                      text: this.$t("Learning Progress in Percentage"),
                  },
                },
                y: {
                    title:{
                        display: true,
                        text: this.$t("Number of Courses"),
                    },
                    ticks:{
                      stepSize: 1,
                    }
                   
                }
            },
            plugins: {
                    legend: {
                        display: true,
                        position: 'bottom',
                    }
            },
          
        };
        return chartOptions
      }
      
    },
    convertDoughnutChart(option, data){
      if(option == 'chartData'){
          let chartData = {
          labels: [this.$t('Passed'), this.$t('Not Passed')],
          datasets: [
            {
              backgroundColor: ['#41B883', '#E46651'],
              data: [data.passed_percent, data.not_passed_percent]
            }
          ]
        }
        return chartData;
      }else{
        let chartOptions = {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
              legend: {
                  display: true,
                  position: 'bottom',
              }
          }
        }
        return chartOptions;
      }
    },
  }
};
</script>
<style lang="scss">
.v-expansion-panel-content__wrap { 
  padding: 0 !important; 
}

.v-timeline {
  padding-top: 0 !important; 
}

.v-card{
overflow-wrap: break-word;
}

.flex-parent-element {
  display: flex;
}

.flex-child-element {
  flex: 1;
  border-bottom: 1px solid #dedede;
}

.module-key{
  cursor: help;
}



</style>
